// PDParent.jsx
import React from "react";
import PDMentorDashboard from "./utils/PDMentorShared";

export const PARENT_CONFIG = {
  userType:       "Parent",
  memberLabel:    "Children",
  memberSingular: "Child",
  memberIcon:     "👧",
  headerIcon:     "👨‍👧",
  headerTitle:    "Parental Engagement",
  headerSub:      "Guide your children's 12-week streak journey",
  accentColor:    "pink",
  targetType:     "Child",
};

export default function PDParent(t, role, currentTheme) {
  return <PDMentorDashboard config={PARENT_CONFIG} role={role}  />;
}